<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <!-- <button class="add-button" data-toggle="modal" (click)="addScreenPrivilegeList()"  data-target="#exampleModal">Add Privilege</button> -->
      <!-- <div class="personal-details">
        <h4 class="personal-details-title">Privilege List</h4>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Seq No</th>
              <th scope="col">Group Name</th>
              <th scope="col">Screen List</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let privilege of privilege | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">
              <th scope="col">{{privilege.seqNo}}</th>
              <th scope="col">{{privilege.groupName}}</th>
              <th scope="col">{{privilege.screenPrivilegeList.length}}</th>
              <th scope="col">
                <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#exampleModalView" (click)="getPrivilegeById(privilege.screenGroupId)"  width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                  <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                </svg> 
            </th>
            </tr>    
          </tbody>
        </table>
        <div class="pagination-block" *ngIf="privilege.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
        </div>
      </div> -->


      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <p>Privilege List</p>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off">
                <input type="text" placeholder="search privilege">
              </form>
              <i class="bi bi-search"></i>
            </div>
            <button *ngIf="actionControls.isAdd" data-toggle="modal" (click)="addScreenPrivilegeList()"
              data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 40%;">Group Name</th>
              <th style="width: 40%;">Screen List</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let privilege of privilege | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
                }  ;let i = index">

            <p style="width: 40%;">{{privilege.groupName}}</p>
            <p style="width: 40%;padding-left: 25px;">{{privilege.screenPrivilegeList.length}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
              <i *ngIf="actionControls.isModify" (click)="getPrivilegeByID(privilege.screenGroupId)" data-toggle="modal"
                data-target="#editModalView" class="bi bi-pencil-square"></i>
              <i *ngIf="actionControls.isView" data-toggle="modal" data-target="#exampleModalView"
                (click)="getPrivilegeById(privilege.screenGroupId)" class="bi bi-eye-fill"></i>
              <i *ngIf="actionControls.isDelete" (click)="del(privilege.id)" data-toggle="modal"
                data-target="#deleteModal" class="bi bi-trash3"></i>
            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && privilege.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>


      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Privilege
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group Seq No</label>
                <input formControlName="seqNo" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group Name</label>
                <input formControlName="groupName" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div *ngFor="let item of screenPrivilegeList;let i = index;let itemLast = last;">
                <div class="productList">
                  <div class="screenName">
                    <p>screen name: {{i+1}}</p>
                  </div>
                  <div class="infoObj">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter seqNo" [(ngModel)]="screenPrivilegeList[i].seqNo">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter name" [(ngModel)]="screenPrivilegeList[i].name">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter description" [(ngModel)]="screenPrivilegeList[i].description">
                  </div>
                  <div class="infoObj1"
                    *ngFor="let infoObj of item.screenPrivilegeScopeList;let j = index;let last = last">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter controllerName"
                      [(ngModel)]="screenPrivilegeList[i].screenPrivilegeScopeList[j].controllerName">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter type" [(ngModel)]="screenPrivilegeList[i].screenPrivilegeScopeList[j].type">
                    <input type="text" class="form-control" [ngModelOptions]="{standalone: true}"
                      placeholder="enter serverPrivilege"
                      [(ngModel)]="screenPrivilegeList[i].screenPrivilegeScopeList[j].serverPrivilege">
                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="last" (click)="addScreenPrivilegeScopeList(i)"
                      fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removeScreenPrivilegeScopeList(i,j)" *ngIf="!last"
                      fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                    </svg>
                  </div>
                </div>
                <div class="" *ngIf="!itemLast" style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
                  <button style="border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;"
                    (click)="removeScreenPrivilegeList(i)">remove</button>
                </div>
                <div class="" *ngIf="itemLast" style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
                  <button *ngIf="i!=0" style="border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;"
                    (click)="removeScreenPrivilegeList(i)">remove</button>
                  <button (click)="addScreenPrivilegeList()"
                    style="margin-left: 10px;border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;">
                    add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="cancelAdd()" class="btn btn-secondary"
            data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" *ngIf="buttonDisable == false" (click)="addPrivilege()">Add
            Privilege</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalView" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privilege
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div *ngFor="let privilege of singlePrivilege; let i = index">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Group Seq No</label>
                <input value="{{privilege.seqNo}}" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Group Name</label>
                <input value="{{privilege.groupName}}" type="text" class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <h5 class="sub-menu-heading">Sub Menus ( {{privilege.screenPrivilegeList.length}} )</h5>
              <div *ngFor="let screenPrivilegeList of privilege.screenPrivilegeList; let j = index">
                <div class="screenList">
                  <div class="sub-menu-block">
                    <div>
                      <label for="">sub menu name :</label>
                      <p> {{screenPrivilegeList.description}}</p>
                    </div>
                    <div>
                      <label for="">router link :</label>
                      <p> {{screenPrivilegeList.name}}</p>
                    </div>
                    <span (click)="selectScreen(j)" data-toggle="modal" data-target="#moveScreen">move</span>
                  </div>
                  <hr>
                  <div class="status-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 25%;">controllerName</th>
                          <th style="width: 10%">type</th>
                          <th style="width: 65%;">serverPrivilege</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let screenPrivilegeScopeList of screenPrivilegeList.screenPrivilegeScopeList;">
                          <td>{{screenPrivilegeScopeList.controllerName}}</td>
                          <td>{{screenPrivilegeScopeList.type}}</td>
                          <td>{{screenPrivilegeScopeList.serverPrivilege}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="updateButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="moveScreen" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Menu
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>

      <div class="select-menu">
        <label for="">select menu</label>
        <select name="" class="form-control" id="" [(ngModel)]="menuId">
          <option value="" selected disabled> -- select menu -- </option>
          <option [value]="privilege.id" *ngFor="let privilege of privilege">{{privilege.groupName}}</option>
        </select>
      </div>

      <div class="modal-body">
        <div class="modal-footer">
          <button type="button" id="menuButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="moveScreen()">Move</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="editModalView" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Update Privilege
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div *ngFor="let privilege of updatePrivilegeList">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group Seq No</label>
                <input type="number" [(ngModel)]="updatePrivilegeList[0].seqNo" value="{{privilege.seqNo}}"
                  class="form-control">
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Group Name</label>
                <input type="text" [(ngModel)]="updatePrivilegeList[0].groupName" value="{{privilege.groupName}}"
                  class="form-control">
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div *ngFor="let screenPrivilegeList of privilege.screenPrivilegeList;let i = index;let itemLast = last;">
                <div class="productList">
                  <div class="screenName">
                    <p>screen name: {{i+1}}</p>
                  </div>
                  <div class="infoObj">
                    <input type="number" [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].seqNo"
                      value="{{screenPrivilegeList.seqNo}}" class="form-control">
                    <input type="text" [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].name"
                      value="{{screenPrivilegeList.name}}" class="form-control">
                    <input type="text" [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].description"
                      value="{{screenPrivilegeList.description}}" class="form-control">
                  </div>

                  <div class="infoObj1"
                    *ngFor="let screenPrivilegeScopeList of screenPrivilegeList.screenPrivilegeScopeList;let j = index;let last = last">
                    <input type="text"
                      [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].screenPrivilegeScopeList[j].controllerName"
                      value="{{screenPrivilegeScopeList.controllerName}}" class="form-control">
                    <input type="text"
                      [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].screenPrivilegeScopeList[j].type"
                      value="{{screenPrivilegeScopeList.type}}" class="form-control">
                    <input type="text"
                      [(ngModel)]="updatePrivilegeList[0].screenPrivilegeList[i].screenPrivilegeScopeList[j].serverPrivilege"
                      value="{{screenPrivilegeScopeList.serverPrivilege}}" class="form-control">

                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="last" (click)="addScreenPrivilegeScopeList(i)"
                      fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removeScreenPrivilegeScopeList(i,j)" *ngIf="!last"
                      fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                    </svg>
                  </div>

                </div>
                <div class="addRemoveButton" style="display: flex;justify-content: flex-end;margin-bottom: 10px;"
                  *ngIf="!itemLast">
                  <button (click)="removeScreenPrivilegeList(i)"
                    style="border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;">remove</button>
                  <button (click)="addScreenPrivilegeList1(i)"
                    style="margin-left: 10px;border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;">add</button>
                </div>
                <div class="addRemoveButton" style="display: flex;justify-content: flex-end;margin-bottom: 10px;"
                  *ngIf="itemLast">
                  <button *ngIf="i!=0" (click)="removeScreenPrivilegeList(i)"
                    style="border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;">remove</button>
                  <button (click)="addScreenPrivilegeList1(i)"
                    style="margin-left: 10px;border: 1px solid rgba(84, 84, 84, 0.526);border-radius: 5px;">add</button>
                </div>
              </div>
            </div>
          </div>


        </div>


        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" id="closeModalButton" (window:keydown.enter)="updatePrivilege()" class="btn btn-primary"
            data-dismiss="modal" (click)="updatePrivilege()">update</button>
        </div>
      </div>
    </div>
  </div>
</div>